export default __webpack_public_path__ + "images/ba55e2c9f63165474067ff5d6e68230f-things-i-like-about-me.svg";